module.exports = __webpack_public_path__ + "static/media/back_icon.0cf60ad9.svg";